export enum Client {
  ios,
  android,
  native,
}

interface NativeInterfaceClient {
  client: Client

  sendEvent(json: string): void
}

export class JSNativeInterface {
  jsInterface: NativeInterfaceClient
  constructor(jsInterface: NativeInterfaceClient) {
    this.jsInterface = jsInterface
  }

  get client(): number {
    return this.jsInterface.client
  }

  sendEvent(name: string, action: string, param: Object) {
    this.jsInterface.sendEvent(
      JSON.stringify({ name: name, action: action, param: param })
    )
  }

  openLive(mediaId: number, broadcastingMethod: number) {
    this.sendEvent('liveView', 'show', {
      mediaId,
      broadcastingMethod,
    })
  }

  openProfile(profileId: string) {
    this.sendEvent('profileView', 'show', {
      profileId,
    })
  }

  openAgeVerification(ageVerificationUrl: string) {
    this.sendEvent('ageVerify', 'show', {
      ageVerificationUrl,
    })
  }
}

class NativeInterfaceClientIOS implements NativeInterfaceClient {
  client = Client.ios

  sendEvent(json: string): void {
    // @ts-ignore
    webkit.messageHandlers.JSInterface.postMessage(json)
  }
}

class NativeInterfaceClientAndroid implements NativeInterfaceClientIOS {
  client = Client.android

  sendEvent(json: string): void {
    // @ts-ignore
    JsInterface.postMessage(json)
  }
}

class NativeInterfaceClientOther implements NativeInterfaceClient {
  client = Client.native

  sendEvent(json: string) {}
}

export const defaultNativeInterfaceClient = (): JSNativeInterface => {
  const ua = navigator.userAgent
  if (ua.indexOf('iPhone') !== -1 || ua.indexOf('iPad') !== -1) {
    return new JSNativeInterface(new NativeInterfaceClientIOS())
  }
  if (ua.indexOf('Android') !== -1) {
    return new JSNativeInterface(new NativeInterfaceClientAndroid())
  }

  return new JSNativeInterface(new NativeInterfaceClientOther())
}
